(function ($) {

    $.fn.extend({

        sorsBanner: function (options) {
            var defaults = {
                maxWidth: 1530,
                maxHeight: 534,
                evenColor: "#ccc",
                oddColor: "#eee"
            };

            var options2 = $.extend(defaults, options);
            var firstWinWidth = $(window).width();

            return this.each(function () {

                var o = options2;
                var obj = $(this);
                var items = $("div.carousel-inner > div.carousel-item", obj);
                var itemsleft = 0;

                $(obj).css("max-width", o.maxWidth).css("max-height", o.maxHeight);

                $(window).resize(function myfunction() {
                    onResize(firstWinWidth, items);
                });

                onResize(firstWinWidth, items);

                $('img.CarouselImg').on('load', function () {
                    onResize(firstWinWidth, items);
                });

            });
        }
    });

})(jQuery);

function onResize($firstWinWidth, $items) {
    var winWidth = $(window).width();

    $($items).each(function () {

        var ow = $("img.CarouselImg", this).data("ow");
        var oh = $("img.CarouselImg", this).data("oh");
        var xw = $("img.CarouselImg", this).width();
        var xh = $("img.CarouselImg", this).height();

        //console.log("###ow:" + ow + ", xw:" + xw, "oh:" + oh + ", xh:" + xh);

        if (xw == 0 || xw == 100) {
            xw = ow;
        }
        if (xh == 0) {
            xh = oh;
        }

        //Banner Text Resize
        $(".BannerText", this).each(function () {
            var ResizeRatio = (ow / xw);
            //console.log("ow:" + ow + ", xw:" + xw, "oh:" + oh + ", xh:" + xh);

            var AW = $(this).data("w");
            var AH = $(this).data("h");
            var AX = $(this).data("x");
            var AY = $(this).data("y");
            var AZ = $(this).data("z");
            var AFC = $(this).data("font-color");
            var AFS = $(this).data("font-size");
            var AFSt = $(this).data("font-style");
            var AFW = $(this).data("font-weight");

            $(this).css({
                "width": AW / ResizeRatio,
                "height": AH / ResizeRatio,
                "margin-top": AY / ResizeRatio,
                "margin-left": AX / ResizeRatio,
                "z-index": AZ,
                "color": AFC,
                "font-size": AFS / ResizeRatio,
                "font-style": AFSt,
                "font-weight": AFW
            });
            //console.log(ResizeRatio);
            //console.log("resizeRatio:" + ResizeRatio + ", AW:" + AW + ", AH:" + AH + ", AX:" + AX + ", AY." + AY + ", AZ:" + AZ + ", AFC:" + AFC + ", AFS" + AFS + ", AGFT:" + AFSt + ", AFW:" + AFW);
        });
    });
}

function PromotionClickGtagDatalayer() {

    $('.BannerText').click(function () {

        var a = $(this);
        var GosterimYeri = a.attr('data-gosterimyeri'); //banner url
        var BannerId = a.attr('data-BannerId');
        var bannerName = a.attr('data-bannerName');

        if (bannerName == "" || bannerName == undefined) {
            bannerName = null;
        }
        if (BannerId == "" || BannerId == undefined) {
            BannerId = null;
        }
        if (GosterimYeri == "" || GosterimYeri == undefined) {
            GosterimYeri = null;
        }

        dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
        dataLayer.push({
            event: "ecom_event",
            event_category: "ecommerce",
            event_action: "select_promotion",
            ecommerce: {
                creative_name: "BSL",
                creative_slot: bannerName,
                location_id: GosterimYeri, //slider vs. olabilir
                promotion_id: BannerId,
                promotion_name: bannerName
            }
        });
    });
}

function PromotionViewGtagDatalayer() {

    var bannerElement = $("#HomeBannerSection .SBanner:first");

    if (bannerElement.length == 0)
        return;

    var bannerRootValue = bannerElement.find('.BannerText');
    var GosterimYeriFirst = bannerRootValue.attr('data-gosterimyeri'); //banner url
    var BannerIdFirst = bannerRootValue.attr('data-bannerid');
    var bannerNameFirst = bannerRootValue.attr('data-bannerName');

    if (bannerNameFirst == "" || bannerNameFirst == undefined) {
        bannerNameFirst = null;
    }
    if (BannerIdFirst == "" || BannerIdFirst == undefined) {
        BannerIdFirst = null;
    }
    if (GosterimYeriFirst == "" || GosterimYeriFirst == undefined) {
        GosterimYeriFirst = null;
    }

    dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
    dataLayer.push({
        event: "ecom_event",
        event_category: "ecommerce",
        event_action: "view_promotion",
        ecommerce: {
            creative_name: "BSL",
            creative_slot: bannerNameFirst,
            location_id: GosterimYeriFirst, //slider vs. olabilir
            promotion_id: BannerIdFirst,
            promotion_name: bannerNameFirst
        }
    });

    var scrolled_val = 0;

    $(window).scroll(function () {
        scrolled_val = $(document).scrollTop().valueOf();
        scrolled_val = parseInt(scrolled_val);

        var bannerElementScroll = $("#HomeBannerSection .SBanner:not(:first)");

        bannerElementScroll.each(function (index, element) {
            var position = $(element).offset();
            position = parseInt(position.top);

            if (scrolled_val > position - 200) {

                if (!$(element).hasClass('datalayerpush')) {
                    $(element).addClass('datalayerpush');

                    var a = $(element).find('.BannerText');
                    var GosterimYeri = a.attr('data-gosterimyeri'); //banner url
                    var BannerId = a.attr('data-bannerid');
                    var bannerName = a.attr('data-bannerName');

                    if (bannerName == "" || bannerName == undefined) {
                        bannerName = null;
                    }
                    if (BannerId == "" || BannerId == undefined) {
                        BannerId = null;
                    }
                    if (GosterimYeri == "" || GosterimYeri == undefined) {
                        GosterimYeri = null;
                    }

                    dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
                    dataLayer.push({
                        event: "ecom_event",
                        event_category: "ecommerce",
                        event_action: "view_promotion",
                        ecommerce: {
                            creative_name: "BSL",
                            creative_slot: bannerName,
                            location_id: GosterimYeri, //slider vs. olabilir
                            promotion_id: BannerId,
                            promotion_name: bannerName
                        }
                    });
                }
            }
        });
    });
}

$(document).ready(function () {

    PromotionClickGtagDatalayer();
    PromotionViewGtagDatalayer();

    $(".SBanner").sorsBanner({
        maxWidth: "auto",
        maxHeight: "auto"
    });


    $(".SBanner").on("swiperight", function (e) {

        $(this).carousel('prev');
        e.stopPropagation();
        e.preventDefault();
    });

    $(".SBanner").on("swipeleft", function (e) {

        $(this).carousel('next');

        e.stopPropagation();
        e.preventDefault();
    });
});
